import { ageGroups } from '@inter-ikea-storageone/range-smastad';
import { GalleryConfig } from 'rangeConfig/@types';
import { ImageType } from '@inter-ikea-storageone/range';

const defaultGallery = [
  {
    title: 'storageone.smastadAgeGroupBaby',
    sprs: [
      { id: 'SPR-09420515' },
      { id: 'SPR-29582856', image: { index: 0, type: ImageType.NSPP } },
      { id: 'SPR-99428748' },
      { id: 'SPR-99483909' },
      { id: 'SPR-49582761' },
      { id: 'SPR-49583237' }
    ],
    ageGroup: ageGroups[0]
  },
  {
    title: 'storageone.smastadAgeGroupChildren',
    sprs: [
      { id: 'SPR-59428825' },
      { id: 'SPR-49544180', image: { index: 0, type: ImageType.NSPP } },
      { id: 'SPR-19388416' },
      { id: 'SPR-19428752', image: { index: 1, type: ImageType.NSPP } },
      { id: 'SPR-99390316' },
      { id: 'SPR-89428310' }
    ],
    ageGroup: ageGroups[1]
  },
  {
    title: 'storageone.smastadAgeGroupTeens',
    sprs: [
      { id: 'SPR-59486071' },
      { id: 'SPR-69544103', image: { index: 0, type: ImageType.NSPP } },
      { id: 'SPR-49428840' },
      { id: 'SPR-89428329' },
      { id: 'SPR-89428999' },
      { id: 'SPR-59549988', image: { index: 0, type: ImageType.NSPP } },
      { id: 'SPR-39542025' }
    ],
    ageGroup: ageGroups[2]
  }
];

const naGallery = [
  {
    title: 'storageone.smastadAgeGroupBaby',
    sprs: [
      { id: 'SPR-29428836' },
      { id: 'SPR-79484189' },
      { id: 'SPR-69541939', image: { index: 0, type: ImageType.NSPP } },
      { id: 'SPR-29555872' },
      { id: 'SPR-49546914' },
      { id: 'SPR-09555868' }
    ],
    ageGroup: ageGroups[0]
  },
  {
    title: 'storageone.smastadAgeGroupChildren',
    sprs: [
      { id: 'SPR-39483399' },
      { id: 'SPR-79428834' },
      { id: 'SPR-59389013' },
      { id: 'SPR-99545403', image: { index: 0, type: ImageType.NSPP } },
      { id: 'SPR-09551078' },
      { id: 'SPR-99555901' },
      { id: 'SPR-79546663' },
      { id: 'SPR-9555892' }
    ],
    ageGroup: ageGroups[1]
  },
  {
    title: 'storageone.smastadAgeGroupTeens',
    sprs: [
      { id: 'SPR-39551067', image: { index: 0, type: ImageType.NSPP } },
      { id: 'SPR-99428437' },
      { id: 'SPR-09545407', image: { index: 0, type: ImageType.NSPP } },
      { id: 'SPR-09431948' },
      { id: 'SPR-29486100' },
      { id: 'SPR-69555846' },
      { id: 'SPR-49435483' },
      { id: 'SPR-09555854' }
    ],
    ageGroup: ageGroups[2]
  }
];

const smastadGalleryConfig: GalleryConfig = {
  default: defaultGallery,
  US: naGallery,
  CA: naGallery,
  DO: naGallery
};

export default smastadGalleryConfig;
